export function isoToDate(isoString: string) {
    return isoString.split('T')[0];
}
